$(document).on('ready turbolinks:load', () => {
  $('.cancel-modal-confirm').on('click', (event) => {
    $('.hide-modal-confirm').modal('hide');
  });
});
